import { SvgIcon } from '@mui/material';
import React from 'react';

const ShippingDefaultIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150.01"
        strokeWidth={0}
        fill="currentColor"
      >
        <path d="m143.21,47.46h-20.93v-26.57H25.9c-6.88,0-12.49,5.61-12.49,12.48v74.78h13.06v.29c0,11.43,9.25,20.68,20.68,20.68s20.71-9.25,20.71-20.68v-.29h40.73v.29c0,11.43,9.28,20.68,20.71,20.68s20.68-9.25,20.68-20.68v-.29h13.43v-34.14l-20.2-26.55ZM47.15,118.9c-5.78,0-10.46-4.68-10.46-10.46,0-.09,0-.2.02-.29.13-5.67,4.75-10.2,10.44-10.2s10.33,4.53,10.46,10.2c.02.09.02.2.02.29,0,5.78-4.68,10.46-10.48,10.46Zm82.14,0c-5.8,0-10.48-4.68-10.48-10.46,0-.09,0-.2.02-.29.07-2.99,1.38-5.67,3.45-7.5,1.87-1.69,4.31-2.7,7.01-2.7,5.69,0,10.31,4.53,10.44,10.2.02.09.02.2.02.29,0,5.78-4.68,10.46-10.46,10.46Zm-7.01-44.88v-16.05h17.12l12.2,16.05h-29.32Z" />
      </svg>
    </SvgIcon>
  );
};

export default ShippingDefaultIcon;
